// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SourceNodeIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SourceNodeIcon" ref={forwardedRef} {...props}>
      <path d="M6.751 4.25a5.75 5.75 0 0 1 5.293 3.5h-1.688a4.25 4.25 0 1 0 0 4.5h1.688A5.751 5.751 0 0 1 1 10a5.75 5.75 0 0 1 5.75-5.75" />
      <path d="m19 10-4.242 4.25-1.062-1.062 2.433-2.437H8.502V9.249h7.627l-2.433-2.437 1.062-1.062z" />
    </SvgIcon>
  );
});

/**
 * Can also be used outside of the "node" context
 * @public
 */
export const SourceNodeIcon = /* @__PURE__ */ Object.assign(
  SourceNodeIconComponent,
  { displayName: 'SourceNodeIcon' },
);
